export default __webpack_public_path__ + "static/media/max.3174d522.png";